// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F517p"};